import { Component, OnInit } from '@angular/core';
import { CategoriaTrabajo } from '../../models/categoriaTrabajo.model';
import { CategoriaTrabajoService } from '../../services/services.index';
import { ModalCategTrabajoService } from '../../components/modal-categ-trabajo/modal-categ-trabajo.service';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;


@Component({
  selector: 'app-categoria-trabajo',
  templateUrl: './categoria-trabajo.component.html',
  styles: []
})
export class CategoriaTrabajoComponent implements OnInit {

  categoriasTrabajo: CategoriaTrabajo[] = [];
  totalRegistros: number;
  desde: number = 0;
  siguienteDisable: boolean = false;
  anteriorDisable: boolean = true;

  loading: boolean = true;

  constructor(public _categoriaTrabajoService: CategoriaTrabajoService,
              public _modalCategTrabajoService: ModalCategTrabajoService) { }

  ngOnInit() {
    this.cargarCategorias();
    this._modalCategTrabajoService.notification.subscribe(resp => {
      this.cargarCategorias();
    });
  }

  cargarCategorias() {
    this.loading = true;
    // Lleno las opciones de Categorias Trabajo
    this.categoriasTrabajo = [];
    this._categoriaTrabajoService.getAllCategoriasTrabajo().subscribe((resp: any) => {
      this.categoriasTrabajo = [];
      for (let categoriaTrabajo of resp.categoriasTrabajo) {
        if (!categoriaTrabajo.parent) {
          this.categoriasTrabajo.push(categoriaTrabajo);
        }
      }
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/categoria-trabajo/categoria-trabajo.component.ts